module.exports = __webpack_public_path__ + "static/media/ua_logo_green_rgb.7e44e1a2.png";